import { useQuery, UseQueryResult } from "react-query";
import { getDoctorAvailability, getDoctorSlots } from "services/availability";
import { DoctorAvailability, Slot } from "services/availability/types";

/** Clés partagées : toute mutation de disponibilité invalide les deux. */
export const DOCTOR_AVAILABILITY_KEY = "doctor-availability";
export const DOCTOR_SLOTS_KEY = "doctor-slots";

/** Semaine type + absences du médecin `doctorId` (désactivé sans médecin). */
export function useDoctorAvailability(
  doctorId: number | null | undefined
): UseQueryResult<DoctorAvailability | null> {
  return useQuery<any, unknown, DoctorAvailability | null>(
    [DOCTOR_AVAILABILITY_KEY, doctorId],
    () => getDoctorAvailability(doctorId as number),
    {
      enabled: doctorId != null,
      select: (result: any) => (result?.ok ? result.data : null),
    }
  );
}

/** Créneaux libres du médecin de `from` à `to` inclus (≤ 31 jours). */
export function useDoctorSlots(
  doctorId: number | null | undefined,
  from: string | null | undefined,
  to: string | null | undefined,
  enabled = true
): UseQueryResult<Slot[]> {
  return useQuery<any, unknown, Slot[]>(
    [DOCTOR_SLOTS_KEY, doctorId, from, to],
    () => getDoctorSlots(doctorId as number, from as string, to as string),
    {
      enabled: enabled && doctorId != null && Boolean(from) && Boolean(to),
      select: (result: any) => (result?.ok && Array.isArray(result.data) ? result.data : []),
    }
  );
}
